import {createRouter,createWebHashHistory} from 'vue-router'
import HomeView from '../views/HomeView.vue'
import AboutView from '../views/AboutView.vue'
import QuickView from '../views/QuickView'
import LongCodeView from '../views/LongCodeView'

const routes = [
  {path: '/', name: 'home', component: AboutView,props:true},
  {path: '/l', name: 'LongCodeView', component: LongCodeView,props:true},
  {path: '/view/:detail', name: 'view', component: HomeView,props:true},
  {path: '/q', name: 'qview', component: QuickView}
]

const router = createRouter({
  history: createWebHashHistory(),
  // base: process.env.BASE_URL,
  base: getAbsolutePath(),
  routes
})
function getAbsolutePath () {
  const path = location.pathname
  const apath= path.substring(0, path.lastIndexOf('/') + 1)
  console.log("apath==",apath)
  return apath
}
export default router
